import React from "react";

function ViewPoster({ service, closeModal }) {

  if (!service) return null;

  const BASE_URL = process.env.REACT_APP_URL;

  const formatDateTime = (isoString) => {
    if (!isoString) return "N/A";
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
const images = service?.images || (service?.image ? [service.image] : []);
  return (
    <div className="modal fade show d-block">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content shadow-lg border-0">

          {/* Header */}
          <div className="modal-header text-white">
            <h5 className="modal-title">Poster Details</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={closeModal}
            ></button>
          </div>

          {/* Body */}
          <div className="modal-body px-4 py-3">

            {/* Info Section */}
            <div className="row mb-3">

              <div className="col-md-6 mb-2">
                <strong>Owner:</strong><br />
                <span>{service?.serviceId?.vendorId?.name || "N/A"}</span>
              </div>

              <div className="col-md-6 mb-2">
                <strong>Service:</strong><br />
                <span>{service?.serviceId?.title || "N/A"}</span>
              </div>

              {/* <div className="col-md-6 mb-2">
                <strong>Status:</strong><br />
                <span className="badge bg-success">
                  {service?.status || "N/A"}
                </span>
              </div> */}

              {/* <div className="col-md-6 mb-2">
                <strong>Request:</strong><br />
                <span className="badge bg-warning text-dark">
                  {service?.approval_status || "N/A"}
                </span>
              </div> */}

              <div className="col-md-6 mb-2">
                <strong>Caption:</strong><br />
               <p className="mb-0">{service?.title || "N/A"}</p>
              </div>

              <div className="col-md-6 mb-2">
                <strong>Date:</strong><br />
                <span>{formatDateTime(service?.createdAt)}</span>
              </div>

            </div>

            {/* Divider */}
            <hr />

            {/* Gallery */}
            <h6 className="mb-3">Gallery</h6>

            <div className="d-flex flex-wrap gap-2">
           {images.length > 0 ? (
  images.map((img, index) => (
    <img
      key={index}
      src={`${BASE_URL}${img}`}
      alt="post"
      style={{
        width: "110px",
        height: "110px",
        objectFit: "cover",
        borderRadius: "10px",
        border: "1px solid #ddd",
        transition: "0.3s",
        cursor: "pointer"
      }}
    />
  ))
) : (
  <p>No Images</p>
)}
            </div>

          </div>

        </div>
      </div>
    </div>
  );
}

export default ViewPoster;